export default __webpack_public_path__ + "static/media/bscchain.6a638b19.svg";